<template>
  <div id="Blank-Page">
    <v-container grid-list-xl fluid>
      <h1>บันทึกส่งพัสดุ</h1>
    </v-container>
    <v-container fluid>
      <v-flex xs12 md4 offset-md4>
        <v-layout row>
          <v-flex md6>
            <v-text-field
              ref="parcel"
              label="รหัส กล่อง/หีบบรรจุ"
              :append-icon="parcel.Input ? 'send' : ''"
              outline
              single-line
              clearable
              v-model="parcel.Input"
              :error-messages="parcel.errorMessage"
              @click:append="parcelEnterScan"
              @keyup.enter="parcelEnterScan "
            ></v-text-field>
          </v-flex>
          <v-flex md6>
            <v-btn fab  @click="enbleCamera">
              <v-icon large >camera</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
               
        

        <!-- <qrcode-drop-zone @decode="onDecode" @init="logErrors">
            <qrcode-stream @decode="onDecode" @init="onInit" />
          </qrcode-drop-zone>

        <qrcode-capture v-if="noStreamApiSupport" @decode="onDecode" />-->

        <!-- <qrcode-stream :camera="camera" @decode="onDecode" @init="onInit" v-if="!destroyed" /> -->
      </v-flex>
    </v-container>
    <v-container fluid>
      <v-flex xs12>
        <v-layout row wrap>
          <v-flex xs12 v-if="onLoadding == false && pickedout.length == 0">
            <v-card>
              <v-card-text class="text-xs-center">
                <v-icon color="orange" x-large>error</v-icon>
                <h2>ไม่พบรายการพัสดุที่นำไปส่ง</h2>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 v-for="(parcel, index) in pickedout" :key="index">
            <v-card class="mt-3">
              <v-card-title>
                <v-icon large left>drafts</v-icon>
                <span
                  class="title font-weight-light"
                >{{ parcel.cust_name }} ({{ parcel.ref_doc_no }})</span>
              </v-card-title>
              <v-card-text>
                <div>{{ parcel.address }}</div>
                <div>จำนวน {{ parcel.boxs }} ชิ้น</div>
              </v-card-text>
              <v-card-actions>
                <v-btn flat icon @click="rejectDrop(parcel)">
                  <v-icon color="error" title="ยกเลิกนำส่ง">block</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                  flat
                  icon
                  :to="{ name: 'dropparcelsubmit', params: { roworderlist: parcel.list_roworder}}"
                >
                  <v-icon color="success" title="บันทึกส่งพัสดุ">camera_enhance</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
          <v-flex xs12 v-if="onLoadding" text-xs-center pa-4>
            <v-progress-circular indeterminate color="amber"></v-progress-circular>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-container>
    <v-dialog v-model="cancel_dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">ยืนยัน</v-card-title>
        <v-card-text>ต้องการยกเลิกการนำส่งพัสดุ หรือไม่</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" @click="cancel_dialog = false">ยกเลิก</v-btn>
          <v-btn
            color="blue darken-1"
            @click="cancel_dialog = false; submitCancelDropParcel();"
          >ยืนยัน</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="scan_dialog" max-width="400px" >
      <v-card>
        <qrcode-stream @decode="onDecode" @init="onInit" v-if="scan_dialog" />
      </v-card>
      <p class="error">{{ error }}</p>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import PackShipService from "@/services/PackShipService";
import authen from "@/store/modules/authen";
import { QrcodeStream } from "vue-qrcode-reader";

export default {
  name: "dropparcel",
  metaInfo: {
    title: "Drop Parcel"
  },
  components: {
    QrcodeStream
    // VWidget,
    // MiniStatistic,
    // VCircle,
    // ProfileCard,
    // CircleStatistic,
    // LinearStatistic,
    // BoxChart
  },
  data: () => ({
    onLoadding: false,
    parcel: {
      input: "",
      errorMessage: ""
    },
    error: "",
    pickedout: [],
    scan_dialog: false,
    destroyed: true,
    cancel_dialog: false,
    cancel_object: {}
  }),
  computed: {},
  methods: {
    ...mapActions("app", ["setTitleText"]),
    async fetchPickedOut() {

      this.onLoadding = true;
      await PackShipService.fetchPickedOut(authen.state.userCode)
        .then(res => {
          if (res.success) {
            this.pickedout = this.mergeParcel(res.parcels);
          }
        })
        .catch(err => {
          // eslint-disable-next-line
          console.log(err);
        });
      this.onLoadding = false;
    },
    mergeParcel(parcels) {
      let result = [];

      parcels.forEach(parcel => {
        let findAddr = result.find(obj => obj.ref_doc_no == parcel.ref_doc_no);

        if (findAddr) {
          // console.log(findAddr.ref_doc_no + " : " + parcel.ref_doc_no);
          findAddr.boxs++;
          findAddr.list_roworder =
            findAddr.list_roworder + "," + parcel.roworder.toString();
          findAddr.parcel_guid_list.push(parcel.parcel_guid)
        } else {
          parcel.boxs = 1;
          parcel.list_roworder = "" + parcel.roworder.toString();
          parcel.parcel_guid_list = []
          parcel.parcel_guid_list.push(parcel.parcel_guid)
          result.push(parcel);
        }
      });
      return result;
    },
    rejectDrop(parcels) {
      this.cancel_object = parcels;
      this.cancel_dialog = true;
    },
    async submitCancelDropParcel() {
      // update service and fetch new data
      console.log(this.cancel_object)
      await PackShipService.submitPickedOutCancelRoworder(this.cancel_object.list_roworder)
      .then(res => {
          
          if (res.data.success) {
            // console.log(parcelID + "Cancel Success ");
            this.cancel_object = {}            
            this.fetchPickedOut();
          }
        })
        .catch(err => {
          // eslint-disable-next-line
          console.log(err);
        });
    },
    async parcelEnterScan() { // หลัง Enter Search
      

      // this.parcelResult = [];
      // //console.log(authen.state.userCode);
      // if (!this.parcel.Input) return;

      // await PackShipService.getPickParcel(this.parcel.Input)
      //   .then(res => {
      //     //console.log(res);

      //     if (res.success) {
      //       this.foundParcel = true;
      //       this.parcel.errorMessage = "";
      //       this.parcel.Input = "";
      //       //this.custName = res.parcels[0].cust_name;
      //       //this.custAddress = res.parcels[0].;
      //       this.parcelResult.push(res.parcel);
      //       //console.log(this.parcelResult);
      //     } else {
      //       this.foundParcel = false;
      //       this.parcel.errorMessage = res.message;
      //     }
      //   })
      //   .catch(err => {
      //     // eslint-disable-next-line
      //     console.log(err);
      //   });

      this.pickedout.forEach((pick) => {
        pick.parcel_guid_list.forEach((guid) => {
          if (guid==this.parcel.Input) {
            this.$router.push({ name: 'dropparcelsubmit', params: { roworderlist: pick.list_roworder}})
          }
        })
      })
    },
    enbleCamera() {
      this.scan_dialog = true
      // this.reset()
      // this.camera = "auto";
      // this.destroyed = false;
    },
    async onInit(promise) {
      try {
        await promise;
      } catch (error) {
        if (error.name === "NotAllowedError") {
          this.error = "ERROR: you need to grant camera access permisson";
        } else if (error.name === "NotFoundError") {
          this.error = "ERROR: no camera on this device";
        } else if (error.name === "NotSupportedError") {
          this.error = "ERROR: secure context required (HTTPS, localhost)";
        } else if (error.name === "NotReadableError") {
          this.error = "ERROR: is the camera already in use?";
        } else if (error.name === "OverconstrainedError") {
          this.error = "ERROR: installed cameras are not suitable";
        } else if (error.name === "StreamApiNotSupportedError") {
          this.noStreamApiSupport = true;
        }
      }
    },
    async onDecode(result) {
      this.result = result;
      this.parcel.Input = result;

      if (result) {
        this.scan_dialog = false
        this.parcelEnterScan();
        // this.turnCameraOff();

        // await PackShipService.getPickParcel(result)
        //   .then(res => {
        //     //console.log(res);

        //     if (res.success) {
        //       this.foundParcel = true;
        //       this.parcel.errorMessage = "";
        //       //this.parcel.Input = "";
        //       //this.custName = res.parcels[0].cust_name;
        //       //this.custAddress = res.parcels[0].;
        //       this.parcelResult.push(res.parcel);
        //       //console.log(this.parcelResult);
        //     } else {
        //       this.foundParcel = false;
        //       this.parcel.errorMessage = res.message;
        //       // this.turnCameraOn();
        //     }
        //   })
        //   .catch(err => {
        //     // eslint-disable-next-line
        //     console.log(err);
        //   });
      }
    },
  },
  mounted() {},
  created() {
    this.fetchPickedOut();
  }
};
</script>
